import * as React from "react";

function SvgDownloadAltDuo({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M24 24H0V0h24z" />
        <path
          fill="#374151"
          d="M18.894 5.106c3.808 3.807 3.808 9.98 0 13.788-3.807 3.808-9.98 3.808-13.788 0-3.808-3.807-3.808-9.98 0-13.788 3.807-3.808 9.98-3.808 13.788 0zM6.166 6.166a8.254 8.254 0 00-1.378 9.844l.142.246 14.142-.004a8.255 8.255 0 00-.839-9.657l-.202-.225-.197-.204-.204-.197-.21-.189a8.251 8.251 0 00-11.254.386zM12 14.75a.847.847 0 01-.113-.008l-.035-.007c-.025-.005-.05-.01-.073-.018l-.036-.012-.067-.028-.036-.019a.92.92 0 01-.074-.046l-.012-.01a.617.617 0 01-.084-.072l-3-3a.749.749 0 01.976-1.133l.084.073 1.72 1.719V7a.75.75 0 011.493-.102L12.75 7v5.189l1.72-1.72a.75.75 0 01.976-.072l.084.073a.75.75 0 01.073.976l-.073.084-3 3a.606.606 0 01-.081.071l.081-.07a.77.77 0 01-.182.133l-.026.014a.993.993 0 01-.09.036l-.008.002-.025.007a.724.724 0 01-.199.027z"
        />
        <path
          fill="#98DB69"
          d="M17.914 17.749l-.08.085a8.252 8.252 0 01-11.464.197l-.286-.28 11.83-.002z"
        />
      </g>
    </svg>
  );
}

export default SvgDownloadAltDuo;
